import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { getAttendanceWorksiteTranslationKey, worksites } from "@msuite/utils/attendances";
import { useMemo } from "react";
import { OrganizationSettingsWorksitesAcknowledgementDefinitions } from "./organization-settings-worksites-acknowledgement-definitions";
import { OrganizationSettingsWorksitesDocuments } from "./organization-settings-worksites-documents";

export function OrganizationSettingsWorksites() {
	/** Hooks */
	const { t } = useTranslation();

	/** Memo */
	const requiredWorksites = useMemo(() => {
		return worksites.filter((worksite) => worksite !== "project-site");
	}, []);

	/** Render */
	return (
		<Tabs
			panelKey="worksite-documents-tabs"
			groups={[
				{
					name: "worksites",
					panels: requiredWorksites.map((worksite) => ({
						label: t(getAttendanceWorksiteTranslationKey(worksite)),
						cyId: `worksite-${worksite}-tab`,
						errors: [],
						panel: () => (
							<Tabs
								panelKey="worksite-requirements-tabs"
								groups={[
									{
										name: "worksite-requirements",
										panels: [
											{
												label: t("documents.documents"),
												cyId: "worksite-documents-tab",
												errors: [],
												panel: () => <OrganizationSettingsWorksitesDocuments worksite={worksite} />,
											},
											{
												label: t("organization.worksite_required_acknowledgements"),
												cyId: "worksite-documents-tab",
												errors: [],
												panel: () => (
													<OrganizationSettingsWorksitesAcknowledgementDefinitions
														worksite={worksite}
													/>
												),
											},
										],
									},
								]}
							/>
						),
					})),
				},
				{
					name: "worksites-off",
					panels: [
						{
							label: t(getAttendanceWorksiteTranslationKey("project-site")),
							cyId: "worksite-project-site-tab",
							errors: [],
							panel: () => (
								<OrganizationSettingsWorksitesAcknowledgementDefinitions worksite="project-site" />
							),
						},
					],
				},
			]}
		/>
	);
}
